// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.final {\n  padding-top: 25px;\n}\n.discountbox {\n  margin-bottom: 25px;\n}\n.secondrow {\n  padding-right: 45px;\n}\n@media (max-width: 768px) {\n.secondrow {\n    padding-right: 0px;\n}\n}", ""]);
// Exports
module.exports = exports;
